import React, { useRef, useEffect } from 'react';
import jdenticon from 'jdenticon';

interface Props {
  size: string;
  value: string;
  className?: string;
}

const Jdenticon = (props: Props) => {
  const { size, value, className } = props;
  const icon = useRef<any>(null);

  useEffect(() => {
    if (icon.current) {
      jdenticon.update(icon.current, value);
    }
  }, [value]);

  return (
    <div className={className}>
      <svg data-jdenticon-value={value} height={size} width={size} ref={icon} />
    </div>
  );
};

export default Jdenticon;
